import React from 'react'
import style from './style.css'

export default class ChatBubble extends React.Component {

    render(){

        return (
            <div className={style.ChatBubbleWrapper}>
                <div className={style.circleGWrapper}>
                    <div className={style.circleG_1 + ' ' + style.circleG}></div>
                    <div className={style.circleG_2 + ' ' + style.circleG}></div>
                    <div className={style.circleG_3 + ' ' + style.circleG}></div>
                </div>
            </div>

        )
    }

}

export {ChatBubble}



// WEBPACK FOOTER //
// ./src/component/TypingIndicator/ChatBubble/index.js